class FacetDeleteAll extends window.BAO.CustomElement() {
  constructor () {
    super()

    switch (this.dataset.type) {
      case 'search':
        this.eventBus = window.theme.searchResults.eventBus
        this.state = {
          root: window.theme.searchResults?.stateLayer?.state || {
            products: [],
          },
          observer: null,
        }
        break
      case 'autocomplete':
        this.eventBus = window.theme.autocompleteResults.eventBus
        this.state = {
          root: window.theme.autocompleteResults?.stateLayer?.state || {
            products: [],
          },
          observer: null,
        }
        break
      default:
        // Default is collection
        this.eventBus = window.theme.category.eventBus
        this.state = {
          root: window.theme.category?.stateLayer?.state || { products: [] },
          observer: null,
        }
    }
  }

  connectedCallback () {
    this.addEventListener('click', this.handleClick)

    if (this.state.root?.activeFacets?.length === 0) {
      this.setAttribute('disabled', 'disabled')
    }
  }

  handleClick () {
    this.eventBus.publish('facets-list:remove-all-filters')
  }
}

window.customElements.define('facet-delete-all', FacetDeleteAll)
